




import { Component, Mixins, Prop } from "vue-property-decorator";
import { IKeyHandleable } from "./IKeyHandleable";

@Component
export default class UndoKeyHandler extends Mixins() implements IKeyHandleable {
  @Prop()
  undone: () => boolean;

  handleKeyDowned(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    if (!event.ctrlKey || (event.key !== "z")) {
      return false;
    }
    if (isInputting) {
      return false;
    }
    return !!this.undone
        && this.undone();
  }

  handleKeyUpped(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    return false;
  }
}
